<template>
  <v-card class="mb-2">
    <v-row >
      <v-col md="3">
        <div class="mr-5">
          <div class="text-lg-right text-h6">{{ title }}</div>
          <div class="text-lg-right text-caption">{{ description }}</div>
          <div v-if="help" class="text-lg-left ml-2 text-caption">
            <div class="text-h6 mt-6 mb-2">Help</div>
            <div v-html="helpText"></div>
          </div>
        </div>
      </v-col>
      <v-col md="8">
        <slot></slot>
      </v-col>
      <v-col md="1">
        <template v-if="canRemove">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                class="ml-3"
                fab
                top
                right
                x-small
                elevation="0"
                v-on:click.prevent="$emit('remove')"
              >
                <v-icon color="red" dark>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Remove</span>
          </v-tooltip>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
const { marked } = require('marked')

export default {
  name: 'query-input-card',
  props: {
    canRemove: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    help: {
      type: String,
      required: false
    },
    category: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {}
  },
  computed: {
    helpText () {
      return marked.parse(this.help)
    }
  }
}
</script>
